import React, {useState, useEffect, useRef, useCallback} from 'react';
import {
    Link,
    useHistory
} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { yourInfoAdded, yourInformationSelector } from '../../../../store/reducers/yourInfoReducer';
import { primaryContractAdded } from '../../../../store/reducers/primConReducer';
import { scrollSelector, classAdded } from '../../../../store/reducers/scrollReducer';
import { useForm } from "react-hook-form";
import { pathAdded } from '../../../../store/reducers/pathsReducer';
import ErrorMessage from "./error/ErrorMessage";
import Tooltip from '../../../registered/tooltip/Tooltip';
import Select from 'react-select';
import { promoCodeSelector } from '../../../../store/reducers/promoCodeReducer';
import {emailValidationRegex, nameValidationRegex, emailValidationRegexAllowPersonal} from "../../../../constants";
import { registrationSettingsSelector } from '../../../../store/reducers/registrationSettingsReducer';
 
function YourInformationLarge({ companyInfo, countryCodeArr }) {
    const promoCode = useSelector(promoCodeSelector);
    const dispatch = useDispatch();
    const yourInfo = useSelector(yourInformationSelector);
    const registrationData = useSelector(registrationSettingsSelector);
    let history = useHistory();
    const scroll = useSelector(scrollSelector);
    const [emailValidation, setEmailValidation] = useState(emailValidationRegex);
    const [countryCode, setCountryCode] = useState(yourInfo.countryCode);
    const [methodValue, setMethodValue] = useState(false);
    const [radioChecked, setRadioChecked] = useState(true);
    const [selectClass, setSelectClass] = useState("react-select");
    const [scrollClass, setScrollClass] = useState(scroll);
    const { register, handleSubmit, formState: { errors }} = useForm();
    const filteredArray = countryCodeArr.filter(code => { return code.value === yourInfo.countryCode})

    useEffect(() => {
        if(countryCode !== undefined) {
            setMethodValue(true)
        };
        if(promoCode.isHuri === true) {
            setEmailValidation(emailValidationRegexAllowPersonal);
        }
        setTimeout(function(){ setScrollClass("progression_container large"); }, 10);
        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
      }, []); // eslint-disable-line

      const [openEmail, setOpenEmail] = useState(false);
      const [openPrim, setOpenPrim] = useState(false);
      const [tooltipClassPrim, setTooltipClassPrim] = useState("more_info-inline");
      const [tooltipClassEmail, setTooltipClassEmail] = useState("more_info-inline");
  
      const span1 = useRef();
      const span2 = useRef();
  
      const handleClick = useCallback(e => {
            if (span1?.current?.contains(e.target)) {
                setOpenPrim(true)
                setTooltipClassPrim("more_info-inline active")
                setTooltipClassEmail("more_info-inline")
                setOpenEmail(false)
                return;
            } else if(span2?.current?.contains(e.target)) {
                setOpenEmail(true)
                setTooltipClassEmail("more_info-inline active")
                setOpenPrim(false)
                setTooltipClassPrim("more_info-inline")
                return;
            } 
            
            setOpenPrim(false)
            setTooltipClassPrim("more_info-inline")
            setTooltipClassEmail("more_info-inline")
            setOpenEmail(false);     
      }, [span1, span2, setOpenPrim, setTooltipClassEmail, setTooltipClassPrim, setOpenEmail]);
  
      useEffect(() => {
          document.addEventListener("mousedown", handleClick);
          return () => {
              document.removeEventListener("mousedown", handleClick);
          };
      }, [handleClick]);

    function onSubmit(data, event) {
        if(methodValue) {    
            data = {
                firstName: data.firstName,
                lastName: data.lastName,
                countryCode: countryCode,
                mobileNum: data.mobileNum,
                email: data.email,
                primary: data.primary
            };
            const data_prim = {
                firstName: data.firstName,
                lastName: data.lastName,
                countryCode: countryCode,
                mobileNum: data.mobileNum,
                email: data.email
            };
            if(data.primary === "yes") {
                dispatch(yourInfoAdded(data));
                dispatch(primaryContractAdded(data_prim));
                dispatch(pathAdded(history.location.pathname));
                history.push("/form/primary");
                dispatch(classAdded("progression_container large startBottom"));
            } else {
                dispatch(yourInfoAdded(data));
                dispatch(pathAdded(history.location.pathname));
                dispatch(classAdded("progression_container large startBottom"));
                history.push("/form/primary");
            }
        }
    };

    function switchRadioNo(e) {
        setRadioChecked(false);
    };

    function switchRadioYes(e) {
        setRadioChecked(true);
    };

    function setMethod(e) {
        setMethodValue(true);
        setCountryCode(e.value);
    };

    function handleSelectClass() {
        setSelectClass("select-error")
    };

    function setClass() {
        dispatch(classAdded("progression_container large startTop"))
    };

    return (
        <>
            <Link to={`/form`} onClick={setClass} className="previous large">Previous <span>
                <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z" fill="white"></path>
                </svg>
            </span></Link> 
            <div className="form-choosenCompany"><span className="your-company-text">Your company:</span> {companyInfo?.name !== "" && <span>{companyInfo.name}</span>}</div> 

            <div className={scrollClass}>
                <h2>Your information</h2>
                <p className="grey-p form">{registrationData.your_info_description}</p>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="billingForm-section1">
                        <div className="form-group name">
                            <label htmlFor="firstName">First name</label>
                            <input 
                                type="text" 
                                defaultValue={yourInfo.firstName}
                                className={errors.firstName ? "errorInput" : ""} 
                                name="firstName" placeholder="Enter your first name" 
                                {...register("firstName", { 
                                    required: "First name is required",
                                    minLength: {
                                        value: 2,
                                        message: "Must be longer than 2 letters"
                                    },
                                    pattern: {
                                        value: nameValidationRegex,
                                        message: "Cannot contain numbers or special characters"
                                    } 
                                })} 
                            />
                            {errors.firstName && <ErrorMessage>{errors.firstName.message}</ErrorMessage>} 
                        </div>
                        <div className="form-group lastName">
                            <label htmlFor="lastName">Last name</label>
                            <input 
                                type="text" 
                                defaultValue={yourInfo.lastName}
                                className={errors.lastName ? "errorInput" : ""} 
                                name="lastName" placeholder="Enter your last name" 
                                {...register("lastName", { 
                                    required: "Last name is required",
                                    minLength: {
                                        value: 2,
                                        message: "Must be longer than 2 letters"
                                    },
                                    pattern: {
                                        value: nameValidationRegex,
                                        message: "Cannot contain numbers or special characters"
                                    } 
                                })} 
                            />
                            {errors.lastName && <ErrorMessage>{errors.lastName.message}</ErrorMessage>}
                        </div>
                    </div>

                    <div className="billingForm-section2">
                        <div className="form-group_container displayFlex">
                            <div className="form-group form-countryCode">
                                <label htmlFor="countryCode">Country code</label>
                                <Select 
                                    className={methodValue === false && selectClass}   
                                    name="countryCode" 
                                    defaultValue={yourInfo.countryCode !== undefined ? {label: filteredArray[0].label, value: yourInfo.countryCode } : {label: " - ", value: "" } }
                                    options={countryCodeArr} 
                                    searchable={false}
                                    onChange={setMethod}
                                    classNamePrefix="react-select"
                                />
                                {(selectClass === "select-error") && (methodValue === false) && <ErrorMessage>Please select a country code</ErrorMessage>}
                            </div>

                            <div className="form-group form-mobile">
                                <label htmlFor="mobileNum">Mobile number</label>
                                <input 
                                    type="text" 
                                    defaultValue={yourInfo.mobileNum}
                                    className={errors.mobileNum ? "errorInput" : ""} 
                                    name="mobileNum" placeholder="Enter your mobile number" 
                                    {...register("mobileNum", { 
                                        required: "Mobile number is required",
                                        pattern: {
                                            value: /^([0-9]){4,12}$/,
                                            message: "invalid phone number. Example (12345678)"
                                        }
                                    })} 
                                />
                                {errors.mobileNum && <ErrorMessage>{errors.mobileNum.message}</ErrorMessage>}
                            </div>
                        </div>

                        <div className="form-group emailCon">
                        <label htmlFor="email">E-mail                    
                            <span 
                                className={tooltipClassEmail} 
                                ref={span2}
                                onClick={handleClick}>                  
                                    {openEmail && (
                                        <Tooltip title="" text={registrationData.your_info_email_information}/>
                                    )}
                            </span>
                        </label>
                        <input 
                            type="text" 
                            className={errors.email ? "errorInput" : ""} 
                            name="email" 
                            placeholder="Enter your email" 
                            defaultValue={yourInfo.email}
                            {...register("email", { 
                                required: "Email is required",
                                pattern: {
                                    value: emailValidation,
                                    message: "Invalid email address. Example: (yourname@yourcompany.no)"
                                }})
                            } 
                        />
                        {errors.email && <ErrorMessage>{errors.email.message}</ErrorMessage>}
                    </div>
                    </div>

                    <div className="radio-group">  
                        <p>Are you the primary contract administrator?   
                            <span 
                                className={tooltipClassPrim} 
                                ref={span1}
                                onClick={handleClick}>                  
                                    {openPrim && (
                                        <Tooltip title="" text={registrationData.your_info_primary_info}/>
                                    )}
                            </span>    
                        </p>    
                        {(yourInfo.primary === undefined) || (yourInfo.primary === "yes") 
                            ?
                                <>
                                    <label className="container">
                                        <input 
                                            type="radio" 
                                            value="yes" 
                                            name="primary" 
                                            onClick={switchRadioYes} 
                                            checked={radioChecked} 
                                            {...register("primary", { required: "Please select an option" })}
                                        />
                                        <span className="checkmark"></span> Yes
                                    </label>
                                    <label className="container">
                                    <input 
                                        type="radio" 
                                        value="no" 
                                        name="primary" 
                                        onClick={switchRadioNo} 
                                        {...register("primary", { required: "Please select an option" })}
                                    />
                                        <span className="checkmark"></span> No
                                    </label>
                                </>
                            : 
                                <>
                                    <label className="container">
                                        <input 
                                            type="radio" 
                                            value="yes" 
                                            name="primary" 
                                            onClick={switchRadioNo}                       
                                            {...register("primary", { required: "Please select an option" })}
                                        />
                                        <span className="checkmark"></span> Yes
                                    </label>
                                    <label className="container">
                                    <input 
                                        type="radio" 
                                        value="no" 
                                        name="primary" 
                                        onClick={switchRadioYes} 
                                        checked={radioChecked} 
                                        {...register("primary", { required: "Please select an option" })}
                                    />
                                        <span className="checkmark"></span> No
                                    </label>
                                </>
                        }
                        {errors.primary && <ErrorMessage>{errors.primary.message}</ErrorMessage>}
                    </div>

                    <div className="button_container">
                        <button onClick={() => { handleSelectClass(); window.plausible('Registration Your Information'); }} className="nextSubmit next" type="submit">
                            <span>Next</span>
                            <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.0815 6.5201L8.27352 8.3281L7.52152 9.0961C6.92952 9.6881 6.30552 10.3121 5.64952 11.0001H7.77752C8.92952 9.8001 11.3615 7.1441 12.7215 5.7841C11.3775 4.4401 8.94552 1.8001 7.77752 0.600098H5.64952C6.30552 1.2881 6.92952 1.9121 7.52152 2.5041L8.27352 3.2721L8.99352 4.0081C9.45752 4.4561 9.84152 4.8721 10.0815 5.0801H0.561523V6.5201H10.0815Z" fill="white"></path>
                            </svg>
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
}

export default YourInformationLarge;
